<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        name="tbl_adv"
        :columns="columns"
        :mod-count="modCount"
        :url="url"
        :pager="false"
        :show-del="false"
        :search-form-fields="formFields"
        :offset-height="offsetHeight"
        :show-column-visible="true"
        :show-add="addPermited"
        @on-add="showFormModalDialog"
        @on-batch-del="onBatchDeleteDone"
      />
      <AdvDetail
        :id="entityId"
        :visible="modalForm"
        :width="560"
        @on-close="onModalClose"
      />
    </div>
  </div>
</template>

<script>
import TableWrapper from '@/components/table-wrapper'
import AdvDetail from './adv-detail'
import request from '@/utils/request'
import { getLabelByCode, getLinkTextStyle } from '@/utils/util'
import { isAdmin, hasPermission } from '@/utils/app'

export default {
  name: 'Ad',
  components: {
    TableWrapper,
    AdvDetail
  },
  data() {
    return {
      url: this.$config.apiContextPath + '/adv/list',
      modalForm: false,
      modalDelConfirm: false,
      entityId: 0,
      modCount: 0,
      timeout: 30000,
      entityName: ''
    }
  },
  computed: {
    addPermited() { return isAdmin() || hasPermission('PEM_ADV_DATA_ADD') },
    deletePermitted() { return isAdmin() || hasPermission('PEM_ADV_DATA_DELETE') },
    updatePermitted() { return isAdmin() || hasPermission('PEM_ADV_DATA_UPDATE') },
    offsetHeight() {
      return 280
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '广告主题', placeholder: '请输入主题名称...', name: 'title', width: 'auto', type: 'input' },
          { label: '显示策略', placeholder: '请选择显示策略...', name: 'showPolicy', width: '140px', type: 'select', options: this.$config.advShowPolicy },
          { label: '是否启用', placeholder: '请选择是否启用', name: 'enabled', width: '150px', type: 'select', hidden: true, options: [
            { label: '禁用', value: 0 },
            { label: '启用', value: 1 }]
          }
        ]
      }
    },
    columns() {
      return [
        { title: '主题名称', align: 'left', key: 'title', width: 160, sortable: true, ellipsis: true, tooltip: true },
        { title: '广告标签', align: 'left', key: 'tag', width: 160, sortable: true, ellipsis: true, tooltip: true },
        { title: '播放时间(s)', align: 'center', key: 'duration', sortable: true, ellipsis: true, tooltip: true },
        { title: '显示策略', align: 'center', key: 'showPolicy', sortable: true, width: 120,
          render: (h, params) => {
            return h('span', {}, getLabelByCode(params.row.showPolicy, this.$config.advShowPolicy))
          }
        },
        { title: '创建时间', align: 'center', sortable: true, key: 'createTime', width: 160, ellipsis: true, tooltip: true },
        { title: '更新时间', align: 'center', sortable: true, key: 'updateTime', width: 160, ellipsis: true, tooltip: true },
        { title: '操作', align: 'center', width: 250, key: '_actions', disabled: true, fixed: 'right',
          render: (h, params) => {
            const _this = this
            return h('div', [
              h('a', {
                style: getLinkTextStyle(_this.updatePermitted),
                on: {
                  click: () => {
                    if (params.row.id && _this.updatePermitted) {
                      this.showFormModalDialog(params.row.id)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-edit': true, 'cell-icon-link': true }}),
                h('span', {}, '编辑')
              ]),
              h('a', {
                style: getLinkTextStyle(_this.deletePermitted),
                on: {
                  click: () => {
                    if (params.row.id && _this.deletePermitted) {
                      this.showDelModalDialog(params.row.id, params.row.title)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-trash': true, 'cell-icon-link': true }}),
                h('span', {
                  domProps: {
                    title: _this.deletePermitted ? '删除广告主题' : '您没有权限删除广告主题'
                  }
                }, '删除')
              ])
            ])
          }
        }
      ]
    }
  },
  methods: {
    showFormModalDialog: function(id = '') {
      this.entityId = id ? parseInt(id) : 0
      this.modalForm = true
    },
    onModalClose: function(changed) {
      this.entityId = 0
      this.modalForm = false
      this.modalDelConfirm = false
      if (changed) {
        this.modCount = this.modCount + 1
      }
    },
    showDelModalDialog: function(id, name) {
      const _this = this
      this.$Modal.confirm({
        title: '确认删除广告主题么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0' }}, [h('li', {}, name)])
        },
        onOk: function() {
          const _that = this
          request({
            url: _this.url + '/' + id,
            method: 'DELETE'
          }).then(res => {
            this.$Notice.success({
              title: '数据删除成功',
              desc: '广告主题 `' + name + '` 删除成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据删除失败',
              desc: '广告主题 `' + name + '` 删除失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    onBatchDeleteDone: function(selections) {
      this.modCount = this.modCount + 1
    }
  }
}
</script>

